"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importStar(require("prop-types"));
const intl_1 = require("@kyruus/intl");
const TimeOfDay_1 = __importDefault(require("../../TimeOfDay/TimeOfDay"));
const button_1 = __importDefault(require("@kyruus/button"));
const styles_1 = require("./styles");
const calendar_1 = require("@kyruus/calendar");
const moment_1 = __importDefault(require("moment"));
const messages_1 = __importDefault(require("../../../lib/messages"));
const LocationsDropdown_1 = __importDefault(require("../../ProviderLocations/LocationsDropdown/LocationsDropdown"));
const DayOfWeekDropdown_1 = __importDefault(require("../DayOfWeek/DayOfWeekDropdown/DayOfWeekDropdown"));
/**
 * A component that provides filtering controls for appointments
 * @param {Object} props - Component props
 * @param {Object} props.filterBy - Current filter settings
 * @param {Set} props.filterBy.timeOfDay - Set containing selected time of day filters
 * @param {Function} props.onTimeOfDayChange - Callback function when time filter changes
 * @param {Object} props.intl - Internationalization object from react-intl
 * @param {Function} props.intl.formatMessage - Function to format internationalized messages
 * @param {Function} [props.track] - Optional analytics tracking function
 * @returns {React.ReactElement} Rendered component
 */
const ApptFilters = ({ bookableLocations, nonBookableLocations, selectedLocationIds, locationId, onSelect, selectedDate, onDateChange, filterBy, onTimeOfDayChange, onDayOfWeekChange, track }) => {
    const [isDatePickerFocused, setIsDatePickerFocused] = (0, react_1.useState)(false);
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(false);
    const handleTimeChange = (value) => {
        track('user_action.direct_book.jump_to_date.time_of_day');
        const timeSet = new Set(value === 'ANYTIME' || value === 'ALL' ? [] : [value]);
        onTimeOfDayChange(timeSet);
    };
    const timeValue = filterBy.timeOfDay.size === 0 ? 'ALL' : [...filterBy.timeOfDay][0];
    return (react_1.default.createElement(styles_1.ApptFilterContainer, null,
        react_1.default.createElement(LocationsDropdown_1.default, { bookableLocations: bookableLocations, nonBookableLocations: nonBookableLocations, selectedLocationIds: selectedLocationIds, locationId: locationId, onSelect: onSelect }),
        react_1.default.createElement(calendar_1.SingleDatePickerDropdown, { focused: isDatePickerFocused, onFocusChange: ({ focused }) => setIsDatePickerFocused(focused || false), date: selectedDate ? (0, moment_1.default)(selectedDate) : (0, moment_1.default)(), onDateChange: onDateChange, label: react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.dateFilterLabel)), block: true, numberOfMonths: 1, hideKeyboardShortcutsPanel: true }),
        isExpanded && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(DayOfWeekDropdown_1.default, { filterBy: filterBy, onSelect: (day, selectedDays) => {
                    const newSelectedDays = new Set(selectedDays);
                    if (newSelectedDays.has(day.id)) {
                        newSelectedDays.delete(day.id);
                    }
                    else {
                        newSelectedDays.add(day.id);
                    }
                    onDayOfWeekChange(newSelectedDays);
                } }),
            react_1.default.createElement("div", { "data-testid": "time-of-day-wrapper", id: "additional-filters" },
                react_1.default.createElement(TimeOfDay_1.default, { value: timeValue, onChange: handleTimeChange })))),
        react_1.default.createElement(button_1.default, { id: "additional-filters-button", mode: "flat", "aria-expanded": isExpanded, "aria-controls": "additional-filters", onClick: () => setIsExpanded(!isExpanded) },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default[isExpanded
                ? 'apptTimeFilterHideFilters'
                : 'apptTimeFilterShowFilters'])))));
};
const LocationProp = (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    id: (0, prop_types_1.oneOfType)([prop_types_1.string, prop_types_1.number]),
    name: prop_types_1.string,
    street1: prop_types_1.string,
    street2: prop_types_1.string,
    suite: prop_types_1.string,
    city: prop_types_1.string,
    state: prop_types_1.string,
    zip: prop_types_1.string
}));
ApptFilters.propTypes = {
    bookableLocations: LocationProp.isRequired,
    nonBookableLocations: LocationProp.isRequired,
    selectedLocationIds: (0, prop_types_1.instanceOf)(Set).isRequired,
    locationId: prop_types_1.default.string,
    onSelect: prop_types_1.default.func.isRequired,
    selectedDate: prop_types_1.default.string,
    onDateChange: prop_types_1.default.func.isRequired,
    filterBy: prop_types_1.default.shape({
        timeOfDay: prop_types_1.default.instanceOf(Set).isRequired
    }).isRequired,
    onTimeOfDayChange: prop_types_1.default.func.isRequired,
    onDayOfWeekChange: prop_types_1.default.func.isRequired,
    intl: prop_types_1.default.shape({
        formatMessage: prop_types_1.default.func.isRequired
    }).isRequired,
    track: prop_types_1.default.func
};
exports.default = (0, intl_1.injectIntl)(ApptFilters);
//# sourceMappingURL=ApptFilters.js.map